<template lang="pug">
  .map-container.geo.forecasts.map-treads
    router-view
    .toolbar
      .toolbar__line
        h1.title.toolbar__title {{$translate('Моделирование')}}
        e-suggestion(
          placeholder=" "
          @selectItem="selectItemOnMapSearch"
          name="q"
          :model="suggestionMapSearch"
          :useInnerSearch="true"
          :options="suggestionMapSearchOptions"
        ).search
        label.switch.switch_gap
          input.switch__input.visually-hidden(type="checkbox" v-model="optimizeThreads")
          span.switch__block
          span Оптимизировать
        .actions-panel.display-flex
          button.reset-btn.button.button_download.button_icon.button_small(@click="getAndSaveScreenshot")
          downloadFile(
            text="KML"
            className="download-kml"
            :url="downloadKMLEndpoint"
          )
          downloadFile(
            text="Shapefile"
            className="download-shape"
            :url="downloadShapefileEndpoint"
          )
    div(v-if="yearList && yearList.length").year-track
      span.year-track__title Дата: {{year}}
      div.year-track__wrapper
        span.year-track__start {{min}}
        div.year-track__path
          el-slider(
            style="width:100%;"
            :min="min"
            :max="max"
            v-model="year"
            @change="yearHandler"
            :step="1"
            show-stops
          )
        span.year-track__end {{max}}
        button.reset-btn.button.button_edit.button_small.button_icon(
          v-if="!$store.getters.isGuest"
          @click="popUpMapShow('showMapPopup',['showMapPopupCreate', 'showMapPopupDelete'])"
        )
        button.reset-btn.button.button_add.button_small.button_icon(
          v-if="!$store.getters.isGuest"
          @click="popUpMapShow('showMapPopupCreate',['showMapPopup', 'showMapPopupDelete'])"
        )
      // лежит в \src\app\geo\components\map-year-track-popup
      map-year-update(
        :openedStateVariable="this.popups.showMapPopup"
        @closeForm="popUpUpdateClose"
      )
      map-year-create(
        :showForm="this.popups.showMapPopupCreate"
        @closeForm="popUpCreateClose"
      )

    .new-map
      div(ref="map" v-once)#map.map.absolute
      map-legend(:showRemoved="true" @showAll="showAll" @showAllThreads="showAllThreads")
</template>

<script>
import DownloadFile from '@/app/geo/components/download-file'
import { map as mapEndpoints } from '@/api/api-endpoints'
import year from '@/utils/year'
import { forecastMixin } from '../mixins/forecast-mixin'
import MapLegend from '../components/map-legend'
import MapYearUpdate from '../components/map-year-update'
import MapYearCreate from '../components/map-year-create'

export default {
  name: 'forecasts',
  components: {
    MapYearUpdate,
    MapLegend,
    MapYearCreate,
    DownloadFile,
  },
  mixins: [forecastMixin],
  methods: {
    changeYear(year) {
      this.yearHandler(year)
      this.threadsDrawer.refreshMap(this.relations)
    },
    getMapTkoObjectsEndpoint(route) {
      return mapEndpoints.objectForThreads(route)
    },
    getThreadEndpoint(route) {
      if (!route.query.year) {
        route.query.year = this.year || year.getCurrentYear()
      }
      return mapEndpoints.threads(route)
    },
    getSettlementEndpoint(route) {
      return mapEndpoints.settlements(route)
    },
    getGarbageSourceEndpoint(route) {
      return mapEndpoints.garbageSources(route)
    },
  },
}
</script>
<style lang="scss" scoped>
.search {
  width: auto;
}
</style>
